<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول درخواست های مرجوعی  </h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                ">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;

                            </a-col>
                        </a-row>
                    </template>

                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-col style="margin-top: 25px" :md="4">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>

                            </a-col>
                            <div class="row">
                              <div class="col-md-6 my-1">
                                <UserSearch @ids="getIds" />
                               
                            </div>
                            <div class="col-md-6 my-1">
                                <label class="sr-only" for="inline-form-input-name">  وضعیت درخواست</label>
                                <a-select style="width: 100%" placeholder=" وضعیت" v-model="search.status">
                                        <a-select-option value="">
                                            انتخاب
                                        </a-select-option>
                                        <a-select-option value="pending">
                                            درانتظار
                                        </a-select-option>
                                        <a-select-option value="accepted">
                                            قبول شده
                                        </a-select-option>
                                        <a-select-option value="denied">
                                            رد شده
                                        </a-select-option>
                                    </a-select>
                            </div>
                            </div>
                                                </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                                                            <div class="table-responsive">

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">نام محصول</th>
                                        <th scope="col">خریدار</th>
                                        <th scope="col">فروشنده</th>
                                                                                <th scope="col">تعداد</th>

                                        <th scope="col"> قیمت نقدی</th>
                                        <th scope="col"> قیمت تهاتری</th>
                                        <th scope="col"> وضعیت درخواست</th>
                                        <th scope="col"> اپراتور</th>
                                        <th scope="col"> مشاهده</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>
                                        {{ row.order_item.product ? row.order_item.product.title : '' }}
                                        </td>
                                        <td>
                                        {{ row.order.user ? $root.full_name(row.order.user.firstname,row.order.user.lastname) : '' }}
                                        </td>

                                        <td>
                                             {{ row.order_item.product.presenter ? $root.full_name(row.order_item.product.presenter.firstname,row.order_item.product.presenter.lastname) : '' }}
                                        </td>

                                             <td>
                                             {{ row.order_item.quantity }}
                                        </td>

                                        <td>
                                        {{ $root.number_format(row.order_item.total_cash) }}
                                               </td>

                                        <td>
                                        {{ $root.number_format(row.order_item.total_barter) }}
                                               </td>
                                        <td>
                                         <b-badge pill v-if="row.status == 'pending'" variant="info" class="bg-warning">
                                                درانتظار</b-badge>
                                                 <b-badge pill variant="info" pill v-else-if="row.status == 'accepted'"  class="bg-success">
                                                قبول شده</b-badge>
                                                 <b-badge pill variant="danger" v-else class="bg-danger">
                                                رد شده</b-badge>
                                        </td>
                                        
                                        <td>
                                             {{ row.operator ? $root.full_name(row.operator.firstname,row.operator.lastname) : '-' }}

                                        </td>
                                         <td>
                                            <ModalReturn @getData="getData" :info="row" />                                          
                                            &nbsp;   
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"
    import ModalReturn from "../../components/Requests/ModalReturn.vue"

    export default {
        components: {
            UserSearch,
            ModalReturn
        },
        data() {
            return {
                data: [],
                statuses: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                  user_id: [],
                  status:"",
                },
            };
        },
        methods: {
            getIds(value) {
                this.search.user_id=value
            },
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url = `/orders/return?page=${this.currentPage}&&user_id=${this.search.user_id}&&status=${this.search.status}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            
        },
        mounted() {
            this.getData();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
